import { ABP, ListService, PagedResultDto, TrackByService } from '@abp/ng.core';
import { tap } from 'rxjs';
import { Router } from '@angular/router';
import { ToasterService } from '@abp/ng.theme.shared';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import {
  AssetDetailsDto,
  AssetService,
  AssetType,
  LifeExpectancyType,
} from '@proxy/register-service/assets';
import { AttributeDefinitionGroupDto } from '@proxy/register-service/attribute-definitions';
import { LocationService } from '@proxy/register-service/locations';
import {
  InspectionDetailsDto,
  GetInspectionsInput,
  InspectionState,
} from '@proxy/servicing-service/inspections';
import { InspectionService } from '@proxy/servicing-service/inspections/inspection.service';
import { ComplianceStatus } from '@proxy/register-service/assets';
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { DateAdapter } from '@abp/ng.theme.shared/extensions';

@Component({
  selector: 'app-asset-infos',
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [ListService, { provide: NgbDateAdapter, useClass: DateAdapter }],
  templateUrl: './asset-infos.component.html',
  styleUrls: ['./asset-infos.component.scss'],
})
export class AssetInfosComponent implements OnInit, OnChanges {
  @Input() asset: AssetDetailsDto;
  @Input() isPageTemporary: boolean = false;
  @Input() tenantPassword: string = '';

  ComplianceStatus = ComplianceStatus;
  isModalBusy = false;
  templateGroup: AttributeDefinitionGroupDto;
  inspections: PagedResultDto<InspectionDetailsDto> = {
    items: [],
    totalCount: 0,
  };
  parentAsset: AssetDetailsDto;
  filters = {} as GetInspectionsInput;
  AssetTypes = AssetType;
  unitLabel = {
    [LifeExpectancyType.Months]: 'Months',
    [LifeExpectancyType.Years]: 'Years',
  };

  constructor(
    public readonly router: Router,
    public readonly list: ListService,
    public readonly service: AssetService,
    public readonly locationService: LocationService,
    public readonly toasterService: ToasterService,
    public readonly track: TrackByService,
    private readonly inspectionService: InspectionService
  ) {}

  ngOnInit() {
    this.parentAsset = this.asset.parent ? { ...this.asset.parent, id: this.asset.parentId } : null;
    this.filters.state = InspectionState.Draft;
    const getData = (query: ABP.PageQueryParams) =>
      this.inspectionService.getList(
        {
          ...query,
          ...this.filters,
          isGroup: true,
          assetPrimaryID: this.asset.primaryID,
          assetId: this.asset.id,
          maxResultCount: 50,
          term: query.filter,
        },
        this.isPageTemporary
      );

    const setData = (list: PagedResultDto<InspectionDetailsDto>) => {
      this.inspections = list;
    };

    this.list.hookToQuery(getData).pipe(tap(setData)).subscribe();
  }

  ngOnChanges({ asset }: SimpleChanges) {
    if (asset?.currentValue && !asset.firstChange) {
      this.parentAsset = this.asset.parent
        ? { ...this.asset.parent, id: this.asset.parentId }
        : null;
    }
  }

  formatAvailability(value: string): string {
    if (!value) return '';
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  }

  create() {
    this.router.navigate(['/assets/create'], { queryParams: { assetId: this.asset.id } });
  }

  onView(record: InspectionDetailsDto) {
    this.router.navigate(['/inspections/details'], {
      queryParams: { id: record.id, assetId: record.assetId, typeId: record.typeId },
    });
  }
}
